import {GetRefundPlans, GetRefundPlansParams, GetRefundPlansResponse} from 'domain/usecases';

import {APIError} from 'data/errors/api-error';
import {HttpClient, HttpStatusCode} from 'data/protocols/http';

export class RemoteRefundGetPlans implements GetRefundPlans {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<GetRefundPlansResponse>,
	) {}

	async get(params: GetRefundPlansParams): Promise<GetRefundPlansResponse> {
		const httpResponse = await this.httpClient.request({
			url: this.url,
			method: 'get',
			params,
		});

		switch (httpResponse.status) {
			case HttpStatusCode.ok:
				return httpResponse.data;
			case HttpStatusCode.created:
				return httpResponse.data;
			case HttpStatusCode.noContent:
				return httpResponse.data;
			default:
				throw new APIError(httpResponse.status, httpResponse.data);
		}
	}
}
